import React from 'react'

// Libs
import classnames from 'classnames'

const Error = ({ index, message, center }) => {
    let textClass = classnames(center ? "text-center" : "text-left", "mb-0", "text-sm", "text-error")
    return (
        <div key={index} className="text-slide-in mb-3"> <p className={textClass}>{message}</p></div>
    )
}

export default Error